import { render, staticRenderFns } from "./aLteBreadcrumbs.vue?vue&type=template&id=21e107d5"
import script from "./aLteBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./aLteBreadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dem/Go/src/github.com/demget/quadroclub/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('21e107d5', component.options)
    } else {
      api.reload('21e107d5', component.options)
    }
    module.hot.accept("./aLteBreadcrumbs.vue?vue&type=template&id=21e107d5", function () {
      api.rerender('21e107d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/breadcrumbs/aLteBreadcrumbs.vue"
export default component.exports